import { render, staticRenderFns } from "./WarehouseCount.vue?vue&type=template&id=1b356b44&scoped=true&"
import script from "./WarehouseCount.vue?vue&type=script&lang=js&"
export * from "./WarehouseCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b356b44",
  null
  
)

export default component.exports